// Common timezones for the timezone selector
export interface TimezoneOption {
  value: string;
  label: string;
  offset: string;
}

export const COMMON_TIMEZONES: TimezoneOption[] = [
  // Australia
  { value: 'Australia/Sydney', label: 'Sydney, Australia', offset: 'AEST/AEDT' },
  { value: 'Australia/Melbourne', label: 'Melbourne, Australia', offset: 'AEST/AEDT' },
  { value: 'Australia/Brisbane', label: 'Brisbane, Australia', offset: 'AEST' },
  { value: 'Australia/Perth', label: 'Perth, Australia', offset: 'AWST' },
  { value: 'Australia/Adelaide', label: 'Adelaide, Australia', offset: 'ACST/ACDT' },
  { value: 'Australia/Darwin', label: 'Darwin, Australia', offset: 'ACST' },
  { value: 'Australia/Hobart', label: 'Hobart, Australia', offset: 'AEST/AEDT' },

  // New Zealand
  { value: 'Pacific/Auckland', label: 'Auckland, New Zealand', offset: 'NZST/NZDT' },
  { value: 'Pacific/Chatham', label: 'Chatham Islands, New Zealand', offset: 'CHAST/CHADT' },

  // United States
  { value: 'America/New_York', label: 'New York, USA (Eastern)', offset: 'EST/EDT' },
  { value: 'America/Chicago', label: 'Chicago, USA (Central)', offset: 'CST/CDT' },
  { value: 'America/Denver', label: 'Denver, USA (Mountain)', offset: 'MST/MDT' },
  { value: 'America/Phoenix', label: 'Phoenix, USA (Arizona, no DST)', offset: 'MST' },
  { value: 'America/Los_Angeles', label: 'Los Angeles, USA (Pacific)', offset: 'PST/PDT' },
  { value: 'America/Anchorage', label: 'Anchorage, USA (Alaska)', offset: 'AKST/AKDT' },
  { value: 'Pacific/Honolulu', label: 'Honolulu, USA (Hawaii)', offset: 'HST' },

  // Canada
  { value: 'America/St_Johns', label: "St. John's, Canada (Newfoundland)", offset: 'NST/NDT' },
  { value: 'America/Halifax', label: 'Halifax, Canada (Atlantic)', offset: 'AST/ADT' },
  { value: 'America/Toronto', label: 'Toronto, Canada (Eastern)', offset: 'EST/EDT' },
  { value: 'America/Winnipeg', label: 'Winnipeg, Canada (Central)', offset: 'CST/CDT' },
  { value: 'America/Regina', label: 'Regina, Canada (Saskatchewan, no DST)', offset: 'CST' },
  { value: 'America/Edmonton', label: 'Edmonton / Calgary, Canada (Mountain)', offset: 'MST/MDT' },
  { value: 'America/Vancouver', label: 'Vancouver, Canada (Pacific)', offset: 'PST/PDT' },

  // United Kingdom & Ireland
  { value: 'Europe/London', label: 'London, UK', offset: 'GMT/BST' },
  { value: 'Europe/Dublin', label: 'Dublin, Ireland', offset: 'GMT/IST' },

  // Europe
  { value: 'Europe/Paris', label: 'Paris, France', offset: 'CET/CEST' },
  { value: 'Europe/Berlin', label: 'Berlin, Germany', offset: 'CET/CEST' },
  { value: 'Europe/Amsterdam', label: 'Amsterdam, Netherlands', offset: 'CET/CEST' },

  // Asia Pacific
  { value: 'Asia/Singapore', label: 'Singapore', offset: 'SGT' },
  { value: 'Asia/Tokyo', label: 'Tokyo, Japan', offset: 'JST' },
  { value: 'Asia/Hong_Kong', label: 'Hong Kong', offset: 'HKT' },
  { value: 'Asia/Shanghai', label: 'Shanghai, China', offset: 'CST' },
  { value: 'Asia/Seoul', label: 'Seoul, South Korea', offset: 'KST' },
  { value: 'Asia/Manila', label: 'Manila, Philippines', offset: 'PHT' },
  { value: 'Asia/Jakarta', label: 'Jakarta, Indonesia', offset: 'WIB' },
  { value: 'Asia/Bangkok', label: 'Bangkok, Thailand', offset: 'ICT' },
  { value: 'Asia/Kolkata', label: 'Mumbai/Delhi, India', offset: 'IST' },
  { value: 'Asia/Dubai', label: 'Dubai, UAE', offset: 'GST' },

  // Africa
  { value: 'Africa/Johannesburg', label: 'Johannesburg, South Africa', offset: 'SAST' },

  // Americas (other)
  { value: 'America/Sao_Paulo', label: 'São Paulo, Brazil', offset: 'BRT' },

  // UTC
  { value: 'UTC', label: 'UTC (Coordinated Universal Time)', offset: 'UTC' },
];

// Get timezone label with offset
export function getTimezoneLabel(timezone: string): string {
  const tz = COMMON_TIMEZONES.find(t => t.value === timezone);
  if (tz) {
    return `${tz.label} (${tz.offset})`;
  }
  return timezone;
}

// Get short timezone code (for display in UI)
export function getTimezoneShortCode(timezone: string): string {
  const tz = COMMON_TIMEZONES.find(t => t.value === timezone);
  return tz?.offset || timezone.split('/').pop() || timezone;
}
